<template>
  <!-- htmlファイル側の「<router-view>」内に表示する内容 -->
  <nav class="" id="vy_header ">
    <h1  v-on:click="home" style="cursor:pointer">
    
        <img id="by-logo" src="../../images/logo.png" alt="ボラ活エール" />
    </h1>
    <div class="container">

      <!--
      <p v-on:click="toiawase" style="cursor:pointer">お問合せ</p>
      <br/>
      <p v-if="GlobalData.$ID_Token.headers.Authorization == ''" v-on:click="login" style="cursor:pointer">ログイン</p>
      <p v-else style="padding: 10px; margin-bottom: 10px; border: 5px double rgb(51, 51, 51); border-radius: 10px; background-color: cyan;">ログイン中です</p>
      <br/>
      <p v-on:click="log_out" style="cursor:pointer">ログアウト</p>-->
      <!--
      <div class="row">
        <div class="col-6 d-flex align-content-end justify-content-end flex-wrap" style="margin: 0;padding: 0;">
          <div class="vy-switch-cap">文字サイズ</div>
          <div id="switchArea01">
            <input type="checkbox" id="switch1" name="vy-css-check" value="text-size">
            <label for="switch1"><span></span></label>
            <div id="swImg01"></div>
          </div>
        </div>
        <div class="col-6 d-flex align-content-end justify-content-end flex-wrap" style="margin: 0;padding: 0;">
          <div class="vy-switch-cap">背景色</div>
          <div id="switchArea02">
            <input type="checkbox" id="switch2" checked  name="vy-css-check" value="bg-color"><label for="switch2"><span></span></label>
            <div id="swImg02"></div>
          </div>
        </div>
      </div>
      -->
    </div>
  </nav>
</template>

<script setup>
/* eslint-disable */
import { useRouter,useRoute } from 'vue-router'
import { login_check } from '../js/userdata_shakyo.js';
const router = useRouter();
let route = useRoute()
const cityname = route.params.shakyo
login_check()

//------------------------------ リンク --------------------------------
const home = function() {
    //document.getElementById("vy_responsive_menu_close").click();
    router.push('/'+cityname+'/Kanri')
}
/*
const toiawase = function() {
    //document.getElementById("vy_responsive_menu_close").click();
    //router.push('/Shakyo/toiawase')
}
const login = function() {
    //document.getElementById("vy_responsive_menu_close").click();
	login_check()
    router.push('/Shakyo/MailLogin')
}
const log_out = function() {
    //document.getElementById("vy_responsive_menu_close").click();
    logout(); router.go('/Shakyo');
}
*/


let manual_open = function(){
    let url = "https://zest-newsprint-e3e.notion.site/17bc0be34f8f80c9899bf966b87e0584?v=8fc1109df997461f978906bdc6784408"
    window.open(url,"_blank")
}
</script>
<style scoped>

</style>


